var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.32 4.945.928.95.005-.004c.814-.751 1.896-1.165 3.048-1.165 1.15 0 2.23.412 3.043 1.16l.01.01.934-.946c-1.07-.968-2.484-1.501-3.987-1.501-1.5 0-2.912.53-3.982 1.496m3.982 2.004c-.554 0-1.075.223-1.432.605l.96.983.453.463.482-.487.959-.97A1.969 1.969 0 0 0 7.3 6.95m0-6.949C4.874 0 2.572.845.812 2.379l.929.95C3.245 2.006 5.219 1.277 7.3 1.277c2.09 0 4.07.734 5.577 2.066l.934-.945C12.05.852 9.74 0 7.302 0",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineIcon);
export default __webpack_public_path__ + "static/media/onlineIcon.17fa846f12b11d12daf617afe2befb0b.svg";
export { ForwardRef as ReactComponent };